import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MailWidgetComponent } from './components/widgets/mail-widget/mail-widget.component';
import { MailLabelComponent } from './components/label/mail-label/mail-label.component';
import { QuillModule } from 'ngx-quill';
import { MailTransmitterPipe } from './pipes/mail-transmitter.pipe';
import { MailInboxComponent } from './components/main/mail-inbox/mail-inbox.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MailListEntryComponent } from './components/embedded/mail-list-entry/mail-list-entry.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SortEMailsPipe } from './pipes/sort-e-mails.pipe';
import { NextcloudModule } from '../nextcloud/nextcloud.module';
import { MsgPreviewDialogComponent } from './components/dialog/msg-preview-dialog/msg-preview-dialog.component';
import { MsgPreviewComponent } from './components/embedded/msg-preview/msg-preview.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MsgCollectionViewComponent } from './components/embedded/msg-collection-view/msg-collection-view.component';
import { IvyCarouselModule } from 'angular-responsive-carousel';
import { SelectEMailAddressComponent } from './components/select/select-e-mail-address/select-e-mail-address.component';
import { MatSelectModule } from '@angular/material/select';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { RecoverSeenMailDialogComponent } from './components/dialog/recover-seen-mail-dialog/recover-seen-mail-dialog.component';

@NgModule({
  declarations: [
    MailWidgetComponent, 
    MailLabelComponent, 
    MailTransmitterPipe,
    MailInboxComponent,
    MailListEntryComponent,
    SortEMailsPipe,
    MsgPreviewDialogComponent,
    MsgPreviewComponent,
    MsgCollectionViewComponent,
    SelectEMailAddressComponent,
    RecoverSeenMailDialogComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    FormsModule,
    MatTooltipModule,
    NextcloudModule,
    MatToolbarModule,
    IvyCarouselModule,
    QuillModule.forRoot()
  ],
  exports: [
    MailWidgetComponent,
    MailInboxComponent,
    MailListEntryComponent,
    MsgPreviewDialogComponent,
    MsgCollectionViewComponent,
    SelectEMailAddressComponent
  ]
})
export class MailModule { }
